import { useEffect } from 'react';
import { getWindow } from '@fluentui/react';
import { IClarityFunctionNames } from '@shared/components';
export const useMsClarityIdentify = ({ correlationId, spzaId })=>{
    useEffect(()=>{
        if (correlationId && spzaId && getWindow()) {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.clarity(IClarityFunctionNames.IDENTIFY, spzaId, correlationId);
        }
    }, [
        spzaId,
        correlationId
    ]);
};
export const useMsClarityTracking = ({ allowTracking })=>{
    useEffect(()=>{
        const currentWindow = getWindow();
        if (allowTracking && (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.clarity)) {
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.clarity(IClarityFunctionNames.CONSENT);
        }
    }, [
        allowTracking
    ]);
};
